/* ============================================================
   SAVIAFLOR — motor de la landing home
   · reveal en cascada al hacer scroll   (patrón xo-animate / xo-cascade)
   · contadores count-up                 (patrón xo-countto de TWP)
   · tabs de specs
   · acordeón de FAQ
   · rotador de la barra de anuncios
   Sin dependencias. Idempotente: se puede llamar dos veces sin romper.
   ============================================================ */
(function () {
  'use strict';

  var soloUnaVez = false;

  /* --------------------------------------------------------
     1 · Reveal en cascada
     -------------------------------------------------------- */
  function armarReveal() {
    var bloques = document.querySelectorAll('.sf-rev:not([data-sf-obs])');
    if (!bloques.length) return;

    if (!('IntersectionObserver' in window)) {
      bloques.forEach(function (b) { b.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    bloques.forEach(function (b) {
      b.setAttribute('data-sf-obs', '1');
      obs.observe(b);
    });

    // Escalona por grupo: cada .sf-cascada reparte 90 ms entre sus hijos .sf-rev
    document.querySelectorAll('.sf-cascada:not([data-sf-casc])').forEach(function (g) {
      g.setAttribute('data-sf-casc', '1');
      var hijos = g.querySelectorAll(':scope > .sf-rev, :scope > * > .sf-rev');
      Array.prototype.forEach.call(hijos, function (h, i) {
        h.style.setProperty('--sf-d', (i * 90) + 'ms');
      });
    });

    // Red de seguridad: lo que siga oculto a los 4 s se muestra igual.
    setTimeout(function () {
      document.querySelectorAll('.sf-rev:not(.is-visible)').forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) b.classList.add('is-visible');
      });
    }, 4000);
  }

  /* --------------------------------------------------------
     2 · Contadores count-up
     <span class="sf-num__cifra" data-sf-hasta="90" data-sf-dur="2200"
           data-sf-sufijo="%">0</span>
     -------------------------------------------------------- */
  function contar(el) {
    if (el.hasAttribute('data-sf-contado')) return; // nunca dos veces
    el.setAttribute('data-sf-contado', '1');
    var hasta = parseFloat(el.getAttribute('data-sf-hasta'));
    if (isNaN(hasta)) return;
    var dur = parseInt(el.getAttribute('data-sf-dur') || '2200', 10);
    var desde = parseFloat(el.getAttribute('data-sf-desde') || '0');
    var dec = parseInt(el.getAttribute('data-sf-dec') || '0', 10);
    var sep = el.getAttribute('data-sf-sep') === 'si';
    var t0 = null;

    function pinta(v) {
      var txt = v.toFixed(dec);
      if (sep) {
        var partes = txt.split('.');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        txt = partes.join(',');
      }
      el.firstChild ? (el.childNodes[0].nodeValue = txt) : (el.textContent = txt);
    }

    // asegura que el primer nodo sea texto para no pisar el <sup>%</sup>
    if (!el.firstChild || el.firstChild.nodeType !== 3) {
      el.insertBefore(document.createTextNode(String(desde)), el.firstChild || null);
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pinta(hasta);
      return;
    }

    function paso(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cúbico
      pinta(desde + (hasta - desde) * eased);
      if (p < 1) requestAnimationFrame(paso);
      else pinta(hasta);
    }
    requestAnimationFrame(paso);
  }

  function armarContadores() {
    var cifras = document.querySelectorAll('[data-sf-hasta]:not([data-sf-listo])');
    if (!cifras.length) return;

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(function (c) { c.setAttribute('data-sf-listo', '1'); contar(c); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        contar(e.target);
      });
    }, { threshold: 0.4 });

    cifras.forEach(function (c) { c.setAttribute('data-sf-listo', '1'); obs.observe(c); });

    // Red de seguridad: si el observer nunca entrega (pestaña abierta en segundo
    // plano, extensión que lo rompe, navegador viejo), un número clavado en 0 es
    // peor que un conteo sin animación. Un solo timeout no alcanza — el visitante
    // puede llegar a la sección mucho después —, así que se chequea cada tanto y
    // el chequeo se apaga solo cuando ya no queda nada por contar.
    var reintentos = 0;
    var reloj = setInterval(function () {
      var faltan = document.querySelectorAll('[data-sf-hasta]:not([data-sf-contado])');
      if (!faltan.length || ++reintentos > 40) { clearInterval(reloj); return; }
      Array.prototype.forEach.call(faltan, function (c) {
        var r = c.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) contar(c);
      });
    }, 1200);
  }

  /* --------------------------------------------------------
     3 · Tabs de specs
     -------------------------------------------------------- */
  function armarTabs(raiz) {
    (raiz || document).querySelectorAll('[data-sf-specs]:not([data-sf-listo])').forEach(function (bloque) {
      bloque.setAttribute('data-sf-listo', '1');
      var tabs = bloque.querySelectorAll('[data-sf-tab]');
      var paneles = bloque.querySelectorAll('[data-sf-panel]');

      function activar(clave) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-sf-tab') === clave;
          t.classList.toggle('is-activo', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        paneles.forEach(function (p) {
          var on = p.getAttribute('data-sf-panel') === clave;
          p.hidden = !on;
          if (on) {
            // re-dispara el reveal de lo que acaba de aparecer
            p.querySelectorAll('.sf-rev').forEach(function (r) { r.classList.add('is-visible'); });
          }
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activar(t.getAttribute('data-sf-tab')); });
      });

      if (tabs.length) activar(tabs[0].getAttribute('data-sf-tab'));
    });
  }

  /* --------------------------------------------------------
     4 · Acordeón de FAQ
     -------------------------------------------------------- */
  function armarFaq(raiz) {
    (raiz || document).querySelectorAll('[data-sf-faq]:not([data-sf-listo])').forEach(function (lista) {
      lista.setAttribute('data-sf-listo', '1');
      lista.querySelectorAll('.sf-faq__item').forEach(function (item) {
        var btn = item.querySelector('.sf-faq__btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var abierto = item.classList.contains('is-abierto');
          if (lista.getAttribute('data-sf-faq') === 'uno') {
            lista.querySelectorAll('.sf-faq__item.is-abierto').forEach(function (o) {
              o.classList.remove('is-abierto');
              var b = o.querySelector('.sf-faq__btn');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('is-abierto', !abierto);
          btn.setAttribute('aria-expanded', !abierto ? 'true' : 'false');
        });
      });
    });
  }

  /* --------------------------------------------------------
     5 · Rotador de la barra de anuncios
     -------------------------------------------------------- */
  function armarAnuncio(raiz) {
    (raiz || document).querySelectorAll('[data-sf-anuncio]:not([data-sf-listo])').forEach(function (barra) {
      barra.setAttribute('data-sf-listo', '1');
      var items = barra.querySelectorAll('.sf-anuncio__item');
      if (items.length < 2) {
        if (items[0]) items[0].classList.add('is-activo');
        return;
      }
      var i = 0;
      items[0].classList.add('is-activo');
      setInterval(function () {
        items[i].classList.remove('is-activo');
        i = (i + 1) % items.length;
        items[i].classList.add('is-activo');
      }, parseInt(barra.getAttribute('data-sf-intervalo') || '3800', 10));
    });
  }

  /* --------------------------------------------------------
     6 · Marquee: duplica la fila para que el loop no corte
     -------------------------------------------------------- */
  function armarMarquee(raiz) {
    (raiz || document).querySelectorAll('[data-sf-marquee]:not([data-sf-listo])').forEach(function (fila) {
      fila.setAttribute('data-sf-listo', '1');
      var hijos = Array.prototype.slice.call(fila.children);
      if (!hijos.length) return;
      // repite hasta cubrir al menos 2x el ancho del viewport, después clona todo
      var vueltas = 0;
      while (fila.scrollWidth < window.innerWidth * 2 && vueltas < 12) {
        hijos.forEach(function (h) { fila.appendChild(h.cloneNode(true)); });
        vueltas++;
      }
      var mitad = Array.prototype.slice.call(fila.children);
      mitad.forEach(function (h) {
        var c = h.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        fila.appendChild(c);
      });
    });
  }

  /* --------------------------------------------------------
     7 · Barra de compra pegada
     Entra cuando el ancla (el CTA del hero) sale de pantalla.
     Se usa scroll y no IntersectionObserver a propósito: acá el
     estado tiene que poder volver atrás, no dispararse una vez.
     -------------------------------------------------------- */
  function armarBarraCompra(raiz) {
    (raiz || document).querySelectorAll('[data-sf-compra]:not([data-sf-listo])').forEach(function (barra) {
      barra.setAttribute('data-sf-listo', '1');
      document.body.classList.add('sf-compra-activa');

      var ancla = document.querySelector(barra.getAttribute('data-sf-ancla') || '.sf-hero__cta');
      var pendiente = false;

      function revisar() {
        pendiente = false;
        var pasado;
        if (ancla) {
          pasado = ancla.getBoundingClientRect().bottom < 0;
        } else {
          pasado = window.scrollY > window.innerHeight * 0.7;
        }
        barra.classList.toggle('is-visible', pasado);
      }

      window.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(revisar);
      }, { passive: true });
      window.addEventListener('resize', revisar, { passive: true });
      revisar();
    });
  }

  /* -------------------------------------------------------- */
  function arrancar() {
    if (!soloUnaVez) {
      document.documentElement.classList.add('sf-anim');
      soloUnaVez = true;
    }
    armarMarquee();
    armarTabs();
    armarFaq();
    armarAnuncio();
    armarBarraCompra();
    armarReveal();
    armarContadores();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de temas recarga secciones sueltas: re-armar lo que aparezca.
  document.addEventListener('shopify:section:load', function () { arrancar(); });

  window.SFHome = { arrancar: arrancar };
})();
